export default "__VITE_ASSET__27366b2b__"